import { render } from "./ClassicEditor.vue?vue&type=template&id=362b16d9"
import script from "./ClassicEditor.vue?vue&type=script&lang=js"
export * from "./ClassicEditor.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src398903933/src/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__